export default __webpack_public_path__ + "static/media/readReviewsDark@2x.0507df1b.png";